import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormView } from '@form/cer-form-view';
import { FieldMetadata } from '@cer/cer-data/cer-data-types';

export const InboundId = "inboundId";
export const Id = "id";

export class RefDataProductInboundContributorCurrentForm extends CerFormAdapter {

  override view(): CerFormView {
    return RefDataProductInboundContributorCurrentForm.contributorView(false);
  }

  public static contributorView(linked: boolean): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'titel-bidragsydere-bop', dataApiName: 'RefDataProductInboundContributorCurrent',
        text: 'Titel bidragsydere BOP', textSingular: 'Titel bidragsyder BOP',
        titleFields: ['keyBeforeName', 'keyName'],
        primaryKey: 'id', baseFields: ['id'],
        parentForeignKey: (linked ? InboundId : null), parentPrimaryKey: (linked ? Id : null),
        allowEdit: false, allowCreate: false, allowDelete: false,
        navigations: [
          { link: 'nav', foreignKey: { parentEntity: 'RefDataProductInboundCurrent', parentColumn: Id, column: InboundId } }
        ]
      },
      fieldMetadata: RefDataProductInboundContributorCurrentForm.fieldMetadata(linked)
    });
  }

  static fieldMetadata(linked: boolean): FieldMetadata[] {
    return [
      { name: "inboundId", text: 'Titel', visible: /*(linked == */false/*)*/ },
      { name: "sequenceNumber", text: "Sortering", orderBy: 'Ascending', visible: false },
      { name: "contributorRole", text: "Rolle", foreignKeyTableName: 'partyRole', foreignKeyField: 'onix', foreignKeyValue: 'onixName' },
      { name: "namesBeforeKey", text: "Fornavn" },
      { name: "keyNames", text: "Efternavn" },
      {
        name: "active", text: "Aktiv", format: "CheckBox", visible: false,
        //  filterOnClient: true, filterOperator: "equal", filterValue: true 
      }
    ];
  }
}

